import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  showPickupFulfillment: attr(Boolean),
  showShipmentFulfillment: attr(Boolean)
});